import React from 'react';
import { Box, Typography, Button, useTheme, useMediaQuery } from '@mui/material';
import blackCardBackground from 'images/placeholder-grey-image.jpg';

const AccessoryIntro = ({ onActivate, onCancel }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '100vh',
        backgroundColor: '#fff',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          width: '100%',
          maxWidth: {
            xs: '100%',
            sm: '440px',
            md: '440px'
          },
          px: 2,
        }}
      >
        <Box
          sx={{
            width: {
              xs: '50%',
              sm: '220px',
              md: '220px'
            },
            height: '100px',
            position: 'relative',
            borderRadius: '10px',
            marginBottom: '50px',
            overflow: 'hidden',
          }}
        >
          <Box
            sx={{
              width: '100%',
              height: '100%',
              backgroundImage: `url(${blackCardBackground})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}
          />
          <Typography
            sx={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              color: '#4f4f4f',
              fontWeight: '600',
              fontSize: '1.125rem',
              letterSpacing: '0.1em',
              fontFamily: '"Helvetica Neue", Arial, sans-serif',
              opacity: 0.4,
              userSelect: 'none'
            }}
          >
            Touch
          </Typography>
        </Box>

        <Typography
          variant="h5"
          sx={{
            fontWeight: 'bold',
            textAlign: 'center',
            color: '#000',
            marginBottom: '16px',
            fontSize: {
              xs: '1.25rem',
              sm: '1.5rem'
            }
          }}
        >
          New Card
        </Typography>

        <Typography
          variant="body1"
          sx={{
            textAlign: 'center',
            color: '#555',
            marginBottom: '32px',
            maxWidth: {
              xs: '280px',
              sm: '320px'
            },
            fontSize: {
              xs: '0.875rem',
              sm: '1rem'
            }
          }}
        >
          This touch device hasn't been activated yet. Want to activate it now?
        </Typography>

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: '16px',
            width: '100%',
            maxWidth: {
              xs: '280px',
              sm: '320px'
            }
          }}
        >
          <Button
            variant="contained"
            onClick={onActivate}
            fullWidth
            sx={{
              backgroundColor: '#000',
              color: '#fff',
              fontWeight: '500',
              borderRadius: '8px',
              padding: '12px',
              textTransform: 'none',
              marginBottom: '8px',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#333',
              },
            }}
          >
            Activate this device
          </Button>

          <Button
            variant="outlined"
            onClick={onCancel}
            fullWidth
            sx={{
              color: '#b0b0b0',
              borderColor: '#b0b0b0',
              borderRadius: '8px',
              padding: '12px',
              textTransform: 'none',
              boxShadow: 'none',
              '&:hover': {
                backgroundColor: '#f5f5f5',
                borderColor: '#999',
              },
            }}
          >
            Cancel
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AccessoryIntro;